import { useEffect, useState } from 'react';

const BADGE_STYLES = [
  'bg-amber-100 text-amber-800',
  'bg-secondary-container/30 text-on-secondary-container',
  'bg-red-100 text-red-700',
  'bg-sky-100 text-sky-800',
  'bg-surface-container-high text-on-surface',
  'bg-purple-100 text-purple-800',
];

/** "AH TO GO" → "AH", "SHELL" → "SHEL", "BP" → "BP": the first word, up to 4 letters. */
export function brandBadgeText(brand) {
  const first = String(brand ?? '').trim().split(/\s+/)[0] ?? '';
  return first.slice(0, 4).toUpperCase() || '?';
}

function badgeStyle(brand) {
  let hash = 0;
  for (const ch of String(brand ?? '').toUpperCase()) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
  return BADGE_STYLES[hash % BADGE_STYLES.length];
}

const SIZES = { sm: 'w-9 h-9 text-[11px]', md: 'w-10 h-10 text-xs', lg: 'w-11 h-11 text-xs', xl: 'w-14 h-14 text-sm' };

/**
 * Brand logo with a coloured text badge ("AH", "SHEL") when there's no URL or the
 * image fails to load. `url` must already be sanitised (http/https only).
 */
export default function BrandLogo({ url, brand, size = 'md', className = '', onLoadError, rounded = 'rounded-lg' }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [url]);
  const box = `${SIZES[size] ?? SIZES.md} ${rounded} flex items-center justify-center overflow-hidden shrink-0 ${className}`;

  if (url && !failed) {
    return (
      <div className={`${box} border border-outline-variant/40 bg-white shadow-sm`}>
        <img
          src={url}
          alt={`${brand || 'Brand'} logo`}
          loading="lazy"
          referrerPolicy="no-referrer"
          onError={() => {
            setFailed(true);
            onLoadError?.();
          }}
          className="w-full h-full object-contain p-1"
        />
      </div>
    );
  }
  return (
    <div className={`${box} font-bold border border-black/5 ${badgeStyle(brand)}`} aria-hidden="true">
      {brandBadgeText(brand)}
    </div>
  );
}
